import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=6326fa89&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=6326fa89&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326fa89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6326fa89')) {
      api.createRecord('6326fa89', component.options)
    } else {
      api.reload('6326fa89', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=6326fa89&scoped=true", function () {
      api.rerender('6326fa89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/statistic/Statistics.vue"
export default component.exports